/* eslint-disable jsx-a11y/anchor-is-valid */
import {WheelchairStatusInfoPanel} from "pages/dashboard/wheelchair/WheelchairStatusInfoPanel"
import {DashboardContentPanel} from "pages/dashboard/map/DashboardContentPanel"
import {
    isEmergencyStatus,
    isErrorStatus,
    isNoneOperationStatus,
    isPowerDisconnectedStatus,
    RealDevice
} from "dto/realdevice/devices"
import DeviceStatusViewByCategory from "pages/dashboard/ttl-status/DeviceStatusViewByCategory"
import {useDashboardMap} from "./map/hook/dashboardmap-hook";
import {useEffect} from "react";
import {NotificationType, showNotification} from "../../common/Notification";
import toast from "react-hot-toast";

export const Dashboard = () => {
    const {powerDisconnectedDevices} = useDashboardMap()
    useEffect(() => {
        if(powerDisconnectedDevices.length > 0) {
            toast.remove()
            showNotification("배터리 전원이 분리된 디바이스가 있습니다.", NotificationType.WARNING)
        }
    }, [powerDisconnectedDevices]);
    return (
        <div className="main-wrapper">
            <WheelchairStatusInfoPanel/>
            <DashboardContentPanel/>
            <DeviceStatusViewByCategory/>
        </div>
    )
}

export function filterDevice(deviceStatusCategory: "ALL" | "NORMAL" | "NON_OPERATION" | "ERROR" | "EMERGENCY" | "POWER_DISCONNECTED", devices: RealDevice[]) {
    if (deviceStatusCategory !== "ALL") {
        if (deviceStatusCategory === "EMERGENCY") {
            devices = devices.filter(dev => isEmergencyStatus(dev))
        } else if (deviceStatusCategory === "NON_OPERATION") {
            devices = devices.filter(dev => isNoneOperationStatus(dev))
        } else if (deviceStatusCategory === 'POWER_DISCONNECTED') {
            devices = devices.filter(dev => isPowerDisconnectedStatus(dev))
        } else if (deviceStatusCategory === "ERROR") {
            devices = devices.filter(dev => isErrorStatus(dev))
        } else {
            devices = devices.filter(dev => !isEmergencyStatus(dev) && !isNoneOperationStatus(dev) && !isErrorStatus(dev))
        }
    }
    return devices
}
